/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AgentPermissions = {
  /**
   * Whether the current human may manage credentials for this agent
   */
  authorize: boolean;
  /**
   * Whether the current human may read this agent
   */
  read: boolean;
  /**
   * Whether the current human may transfer or reassign this agent
   */
  transfer: boolean;
  /**
   * Whether the current human may configure or change this agent
   */
  write: boolean;
};

/** @internal */
export const AgentPermissions$inboundSchema: z.ZodMiniType<
  AgentPermissions,
  unknown
> = z.object({
  authorize: z.boolean(),
  read: z.boolean(),
  transfer: z.boolean(),
  write: z.boolean(),
});

export function agentPermissionsFromJSON(
  jsonString: string,
): SafeParseResult<AgentPermissions, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPermissions$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPermissions' from JSON`,
  );
}
